import * as yup from 'yup';
import { yupUtils, isValidYupSchema } from '../../utils/yup/utils';
import { ProjectErrorType, ProjectErrors } from '../../utils/errors/types';
import { getProjectErrorForCode, getProjectErrorFromRawError, isProjectError } from '../../utils/errors';
import { MentorBoard } from '../types/mentorBoard';

export const MAX_MENTOR_BOARD_MEMBERS = 5;

const MentorBoardMemberSchema = yup.object().shape({
  authorId: yupUtils.stringRequired(),
  title: yup.string().optional(),
  courseContentGroupId: yupUtils.stringOptionalNullable,
});

const MentorBoardMemberFormSchema = yup.object().shape({
  authorId: yupUtils.stringRequired(),
  title: yupUtils.stringRequired('Add a short title for this member'),
  courseContentGroupId: yupUtils.stringOptionalNullable,
});

export const MinimalMentorBoardSchema = yup.object().shape({
  title: yupUtils.stringRequired('The board title is required'),
  subtitle: yupUtils.stringRequired('The board subtitle is required'),
  description: yupUtils.stringRequired('The board description is required'),
  isActive: yupUtils.booleanRequired,
  members: yup
    .array()
    .of(MentorBoardMemberFormSchema)
    .max(MAX_MENTOR_BOARD_MEMBERS, `Select up to ${MAX_MENTOR_BOARD_MEMBERS} members`)
    .required(),
});

export const MentorBoardSchema = yup.object().shape({
  id: yupUtils.stringRequired(),
  title: yupUtils.stringRequired('The board title is required'),
  subtitle: yupUtils.stringRequired('The board subtitle is required'),
  description: yupUtils.stringRequired('The board description is required'),
  order: yupUtils.numberOptionalNullable,
  isActive: yupUtils.booleanRequired,
  memberAuthorIds: yupUtils.arrayOfOptionalStrings,
  members: yupUtils.arrayOptionalNullableOf(MentorBoardMemberSchema),
});

export const parseMentorBoard = async (object: any): Promise<MentorBoard | ProjectErrorType> => {
  try {
    if (await isValidYupSchema(MentorBoardSchema, object)) {
      return object as MentorBoard;
    }
    return getProjectErrorForCode(ProjectErrors.invalidMentorBoard);
  } catch (error) {
    console.log(`[MENTOR BOARDS] ID: ${object?.id}. Error:`, error);
    return getProjectErrorFromRawError(error as Error);
  }
};

export const parseMentorBoards = async (items: any): Promise<MentorBoard[]> => {
  if (!(items && Array.isArray(items))) {
    console.log('[MENTOR BOARDS] Error: No array found.');
    return [];
  }

  const data: MentorBoard[] = [];
  for (const item of items) {
    const o = await parseMentorBoard(item);
    if (o && !isProjectError(o)) {
      data.push(o as MentorBoard);
    }
  }

  return data;
};
